import axios from "axios";
const API_URL = "https://commune-botmakak.net/api/v1";
const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response?.status === 401) {
      const refresh = localStorage.getItem("refresh_token");
      if (refresh) {
        try {
          const res = await axios.post(`${API_URL}/auth/token/refresh/`, { refresh });
          localStorage.setItem("access_token", res.data.access);
          error.config.headers.Authorization = `Bearer ${res.data.access}`;
          return api(error.config);
        } catch {
          localStorage.clear();
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);
export const authService = {
  login: (email, password) => api.post("/auth/login/", { email, password }),
  getProfile: () => api.get("/auth/profile/"),
};
export const newsService = {
  getPosts: (params) => api.get("/news/posts/", { params }),
  createPost: (data) => api.post("/news/posts/create/", data),
  deletePost: (id) => api.delete(`/news/posts/${id}/manage/`),
  updatePost: (id, data) => api.patch(`/news/posts/${id}/manage/`, data),
  getCategories: () => api.get("/news/categories/"),
};
export const reportsService = {
  getReports: (params) => api.get("/news/reports/", { params }),
  updateReport: (id, data) => api.patch(`/news/reports/${id}/`, data),
};
export const usersService = {
  getProfile: () => api.get("/auth/profile/"),
};
export const civilService = {
  getRequests: () => api.get("/civil-status/requests/"),
  updateRequest: (id, data) => api.patch(`/civil-status/requests/${id}/`, data),
};
export const eventsService = {
  getEvents: () => api.get("/events/"),
  createEvent: (data) => api.post("/events/create/", data),
};
export default api;